<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <thead>
  <tr>
    <th scope="col" class="col-3">
      Employee
    </th>
    <th @click="(e)=>{this.addRota(e,moment.clone().add(num, 'days'))}" v-for="num in numbers" scope="col" class="col-3"
        :key="num">
      {{ moment.clone().add(num, "days").format("dd Do") }}
    </th>

    <th scope="col" class="col-3">
      Totals
    </th>
  </tr>
  </thead>
</template>

<script>
import {Appointment} from "../classes/Appointment";

export default {
  name: "ScheduleLineHeader",
  props: {
    moment: {
      type: Object,
      required: true,
    },
    showPay: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.setNumbers();
  },
  data() {
    return {
      numbers: [],
    }
  },
  emits: ["choosetoday", "rotachosen"],
  methods: {
    addRota(evt, today) {
      evt.stopImmediatePropagation();
      this.$emit("choosetoday", today);
      let rota = new Appointment();
      this.$emit("rotachosen", rota);

    },
    setNumbers() {
      ////////console.log(this.mom.format("dd"));
      let startNum = 0;
      this.numbers = [];
      switch (this.moment.format("dd")) {
        case "Su":
          startNum = 0;
          break;
        case "Mo":
          startNum = -1;
          break;
        case "Tu":
          startNum = -2;
          break;
        case "We":
          startNum = -3;
          break;
        case "Th":
          startNum = -4;
          break;
        case "Fr":
          startNum = -5;
          break;
        case "Sa":
          startNum = -6;
          break;


      }// end switch
      let ctr = 0;
      while (ctr <= 6) {
        this.numbers.push(startNum + ctr);
        ctr++;
      }

    },
  },
  computed: {
    loggedInUser() {
      return this.$store.state.loggedInUser;
    }
  },
}
</script>

<style scoped>

</style>
